
import Shop from './shop';

const RealtimeFilters = {};

RealtimeFilters.dynamicFilterBrands = function() {
	const selectedBrands = Shop.getActiveFilters( 'brands' ) || [];
	if ( ! selectedBrands || selectedBrands.length <= 0 ) {
		return [];
	}

	return {
		'field': 'brand',
		'arguments': selectedBrands.map( ( brand ) => {
			const label = brand.label;
			const split = brand.value.split( '$$' );

			return {
				'action': 'IS',
				'value': label || split[ 0 ],
			};
		} ),
	};
};

RealtimeFilters.dynamicFilterThemes = function() {
	const selectedThemes = Shop.getActiveFilters( 'themes' ) || [];
	if ( ! selectedThemes || selectedThemes.length <= 0 ) {
		return [];
	}

	const filterMapper = {
		'gender': [],
		'kids': [],
	};

	selectedThemes.forEach( ( theme ) => {
		// Custom Filters for Girls/Boys.
		if ( [ 'MÄDCHEN', 'JUNGEN' ].indexOf( theme.value.toUpperCase() ) !== -1 ) {
			filterMapper.kids.push( theme );
		} else {
			filterMapper.gender.push( theme );
		}
	} );

	// Extract correct filtervalues.
	return Object.keys( filterMapper ).map( ( field ) => {
		const themes = filterMapper[ field ];
		if ( themes.length <= 0 ) {
			return false;
		}

		return {
			field,
			'arguments': themes.map( ( theme ) => {
				return {
					'action': 'IS',
					'value': theme.value,
				};
			} ),
		};
	} ).filter( ( i ) => i );
};

RealtimeFilters.dynamicFilterBadges = function() {
	const selectedBadges = Shop.getActiveFilters( 'badges' ) || [];
	if ( ! selectedBadges || selectedBadges.length <= 0 ) {
		return [];
	}

	return selectedBadges.map( ( badge ) => {
		let field = badge.value.toLowerCase().replace( /\s+/g, '_' ).replace( 'ä', 'ae' ).replace( 'ö', 'oe' ).replace( 'ü', 'ue' ).replace( '_♡_', 'love' ).replace( 'ß', 'ss' );

		if ( 'nachhaltig' === field ) {
			field = 'wear_fair';
		}

		return {
			field,
			'arguments': [
				{
					'action': 'IS',
					'value': 'true',
				},
			],
		};
	} );
};

RealtimeFilters.dynamicFilterPseries = function() {
	const selectedPseries = Shop.getActiveFilters( 'productseries' ) || [];
	if ( ! selectedPseries || selectedPseries.length <= 0 ) {
		return [];
	}

	return {
		'field': 'produktserie',
		'arguments': selectedPseries.map( ( pseries ) => {
			return {
				'action': 'IS',
				'value': pseries.value,
			};
		} ),
	};
};

RealtimeFilters.dynamicFilterSeasons = function() {
	const selectedSeasons = Shop.getActiveFilters( 'saisons' ) || [];
	if ( ! selectedSeasons || selectedSeasons.length <= 0 ) {
		return [];
	}

	const seasons = { 31: 'summer', 32: 'winter' };

	return {
		'field': 'saison',
		'arguments': selectedSeasons.map( ( season ) => {
			return {
				'action': 'IS',
				'value': seasons[ season.value ],
			};
		} ),
	};
};

RealtimeFilters.dynamicFilterSaleNew = function() {
	const selectedFilters = Shop.getActiveFilters( 'salenew' ) || [];
	if ( ! selectedFilters || selectedFilters.length <= 0 ) {
		return [];
	}

	return selectedFilters.map( ( filter ) => {
		// No empty filters.
		if ( ! parseInt( filter.value ) ) {
			return false;
		}

		return {
			'field': filter.name,
			'arguments': [
				{
					'action': 'IS',
					'value': 'true',
				},
			],
		};
	} ).filter( ( i ) => i );
};

RealtimeFilters.dynamicFilterNewArrived = function() {
	const selectedFilters = Shop.getActiveFilters( 'newarriveds' ) || [];
	// eslint-disable-next-line no-unused-vars
	let selectedValue = [];

	if ( ! selectedFilters || selectedFilters.length <= 0 ) {
		return [];
	}

	return selectedFilters.map( ( filter ) => {
		switch ( filter.value ) {
			case '7':
				selectedValue = [ {
					'action': 'IS',
					'value': '7',
				} ];
				break;
			case '14':
				selectedValue = [ {
					'action': 'IS',
					'value': '7',
				},
				{
					'action': 'IS',
					'value': '14',
				} ];
				break;
			case '30':
				selectedValue = [ {
					'action': 'IS',
					'value': '7',
				},
				{
					'action': 'IS',
					'value': '14',
				},
				{
					'action': 'IS',
					'value': '30',
				} ];
				break;
			default:
				selectedValue = [
					{
						'action': 'LTE',
						'value': filter.value,
					},
				];
				break;
		}
		return {
			'field': 'NewArrived',
			'arguments': selectedValue,
		};
	} );
};

RealtimeFilters.dynamicFilterConditions = function( options = {} ) {
	const selectedBrands = RealtimeFilters.dynamicFilterBrands();
	const selectedThemes = RealtimeFilters.dynamicFilterThemes();
	const selectedBadges = RealtimeFilters.dynamicFilterBadges();
	const selectedPseries = RealtimeFilters.dynamicFilterPseries();
	const selectedSeasons = RealtimeFilters.dynamicFilterSeasons();
	const dynamicSaleNew = RealtimeFilters.dynamicFilterSaleNew();
	const dynamicNewArrived = RealtimeFilters.dynamicFilterNewArrived();

	const selected = {
		'brands': selectedBrands,
		'themes': selectedThemes,
		'badges': selectedBadges,
		'productseries': selectedPseries,
		'season': selectedSeasons,
		'salenew': dynamicSaleNew,
		'newarriveds': dynamicNewArrived,
	};

	let types = Object.keys( selected );

	if ( options.include ) {
		types = [].concat( options.include );
	}

	if ( options.exclude ) {
		const exclude = [].concat( options.exclude );
		types = types.filter( ( type ) => ! exclude.includes( type ) );
	}

	return types.reduce( ( result, type ) => {
		return result.concat( selected[ type ] );
	}, [] ).filter( ( i ) => i );
};

RealtimeFilters.dynamicFilterContext = function( options = {} ) {
	const conditions = RealtimeFilters.dynamicFilterConditions( options );

	if ( conditions.length <= 0 ) {
		return {};
	}

	return {
		'realtimeRules': [ {
			'id': -4,
			'query': {
				conditions,
			},
			'type': 'include',
			'slots': [],
		} ],
	};
};

RealtimeFilters.getContextData = function( { action, options } ) {
	const { customParam = '' } = options;

	switch ( action ) {
		case 'product':
		case 'cart':

			return {
				'context': {
					'type': action.toUpperCase(),
					'data': [].concat( customParam.split( ';' ) ),
				},
			};

		case 'category':

			return {
				'realtimeRules': [ {
					'id': -2,
					'query': {
						'conditions': [ {
							'field': 'allCategories',
							'arguments': [ {
								'action': 'CONTAINS',
								'value': customParam,
							} ],
						} ],
					},
					'type': 'include',
					'slots': [],
				} ],
			};

		case 'brand':

			return {
				'realtimeRules': [ {
					'id': -3,
					'query': {
						'conditions': [
							{
								'field': 'brand',
								'arguments': [ {
									'action': 'IS',
									'value': customParam,
								} ],
							},
						//...RealtimeFilters.dynamicFilterConditions( { 'exclude': 'brands' } ),
						],
					},
					'type': 'include',
					'slots': [],
				} ],
			};

		case 'pseries':

			const [ brand, pseries ] = customParam.split( '|' );
			return {
				'realtimeRules': [ {
					'id': -4,
					'query': {
						'conditions': [
							{
								'field': 'brand',
								'arguments': [ {
									'action': 'IS',
									'value': brand,
								} ],
							},
							{
								'field': 'produktserie',
								'arguments': [ {
									'action': 'IS',
									'value': pseries,
								} ],
							},
						],
					},
					'type': 'include',
					'slots': [],
				} ],
			};

		// Realtime filters based on Shopvalues.
		case 'filter':
			return RealtimeFilters.dynamicFilterContext();

		// This is the new default, everything above is legacy stuff.
		case 'options':
			return {
				...options,
				'realtimeRules': [].concat( Object.values( options.realtimeRules || [] ) ).map( ( rule, index ) => {
					rule.id ??= ( Math.abs( index ) + 1 ) * -1;
					return rule;
				} ),
			};

		case 'none':
		case 'auto':
		default:

			break;
	}

	return {};
};

RealtimeFilters.getWidgetOpts = function( action, options ) {
	// Get Context.
	const opts = RealtimeFilters.getContextData( { action, options } );

	// Limit.
	if ( ! ( 'maxProducts' in opts ) ) {
		const { maxProducts = -1 } = options;
		if ( maxProducts > 0 ) {
			opts.maxProducts = maxProducts;
		}
	}

	// Deduplicate.
	if ( ! ( 'distinct' in opts ) ) {
		const { distinct = false } = options;
		opts.distinct = distinct || false;
	}

	// Sanity check keys.
	// @see https://support.dynamicyield.com/hc/en-us/articles/360022557954-Recommendations-Client-side-APIs
	const keys = [ 'context', 'maxProducts', 'exclude', 'realtimeRules', 'distinct' ];
	return Object.fromEntries(
		Object.entries( opts ).filter( ( [ key, val ] ) => {
			if ( 'maxProducts' === key && val <= 0 ) {
				return false;
			}

			return keys.includes( key );
		} ),
	);
};

export default RealtimeFilters;
